module.exports = __webpack_public_path__ + "images/cagivad44bc63301039ecda3c7a7ca49181fca.png";